import React from 'react';
import { RuleStepEvaluation } from '@decisions/server/DecisionsFramework/Design/Flow/Service/Debugging/DebugData/RuleStepEvaluation';
import { ListStepEvaluationItem } from './ListStepEvaluationItem';

export interface IFullListStepEvaluationProps extends React.HTMLProps<{}> {
  evaluations: RuleStepEvaluation[];
}

/**
 * Displays full evaluation list. If you need to limit it use [[ListSteEvaluation]]
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function FullListStepEvaluation({ evaluations }: IFullListStepEvaluationProps) {
  return (
    <ol>
      {evaluations.map((item, index) => (
        <ListStepEvaluationItem key={`${item.Anchor} ${item.Verb} ${index}`} evaluation={item} index={index + 1} />
      ))}
    </ol>
  );
}
